import { render, staticRenderFns } from "./IPadLayout.vue?vue&type=template&id=0ac8a808&scoped=true"
import script from "./IPadLayout.vue?vue&type=script&lang=js"
export * from "./IPadLayout.vue?vue&type=script&lang=js"
import style0 from "./IPadLayout.vue?vue&type=style&index=0&id=0ac8a808&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac8a808",
  null
  
)

export default component.exports